import styled from 'react-emotion';

import theme from './theme';

const Link = styled.a`
	cursor: pointer;
	color: ${theme.colors.secondaryColor};
	text-decoration: none;
	font-weight: bold;
	font-size: 1.0rem;

	&:hover {
		color: ${theme.colors.primaryColor};
	}
`;

export default Link;



// WEBPACK FOOTER //
// ./src/styles/Link.js